import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Mail, 
  Phone, 
  MapPin, 
  Facebook, 
  Twitter, 
  Linkedin, 
  Github,
  Heart
} from 'lucide-react';

const Footer = ({ className = "lg:ml-64" }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`bg-gray-900 text-white ${className}`}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Main footer content */}
        <div className="py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company info */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold">DVT_HULO_SYSTEM</h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                Hệ thống quản lý đơn hàng, design, và marketing.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  <Facebook className="h-5 w-5" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  <Twitter className="h-5 w-5" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  <Linkedin className="h-5 w-5" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  <Github className="h-5 w-5" />
                </a>
              </div>
            </div>

            {/* Quick links */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold">Liên kết nhanh</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/dashboard" className="text-gray-300 hover:text-white transition-colors">
                    Dashboard
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/products" className="text-gray-300 hover:text-white transition-colors">
                    Sản phẩm
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/users" className="text-gray-300 hover:text-white transition-colors">
                    Người dùng
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/profile" className="text-gray-300 hover:text-white transition-colors">
                    Hồ sơ
                  </Link>
                </li>
              </ul>
            </div>

            {/* Support */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold">Hỗ trợ</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <a href="#" className="text-gray-300 hover:text-white transition-colors">
                    Hướng dẫn sử dụng
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-300 hover:text-white transition-colors">
                    FAQ
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-300 hover:text-white transition-colors">
                    Báo cáo lỗi
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-300 hover:text-white transition-colors">
                    Yêu cầu tính năng
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact info */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold">Liên hệ</h3>
              <div className="space-y-3 text-sm">
                <div className="flex items-center space-x-3">
                  <Mail className="h-4 w-4 text-gray-400" />
                  <span className="text-gray-300">support@hulo.com</span>
                </div>
                <div className="flex items-center space-x-3">
                  <Phone className="h-4 w-4 text-gray-400" />
                  <span className="text-gray-300">+84 123 456 789</span>
                </div>
                <div className="flex items-center space-x-3">
                  <MapPin className="h-4 w-4 text-gray-400" />
                  <span className="text-gray-300">Đà Nẵng, Việt Nam</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom footer */}
        <div className="border-t border-gray-800 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-2 text-sm text-gray-400">
              <span>© {currentYear} DVT_HULO_SYSTEM. Tất cả quyền được bảo lưu.</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-gray-400">
              <span>Được tạo với</span>
              <Heart className="h-4 w-4 text-red-500" />
              <span>tại Việt Nam</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
